import { giphyBlack, giphyWhite } from '@giphy/js-brand'
import styled from 'styled-components'

export const SendingGif = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    display: none;
    opacity: 0.9;
    z-index: 2;
    height: 100%;
    width: 100%;
    color: ${giphyWhite};
    align-items: center;
    justify-content: center;
    padding: 10px;
    background-color: ${giphyBlack};
    font-family: Interface;
`
